import { observable } from "mobx"
import moment from "moment";
import AtualizacaoCadastralService from "../../../services/AtualizacaoCadastralService"
import FileSaver from 'file-saver'
import { toast } from "react-toastify";
import { sortCaret } from '../../comum/components/Icones';
import { formatarDataCustomHTML, statusNotaFormatter } from '../../../utils/formatar';

export default class LogsStore {

    @observable LogEmailLista;

    @observable tiposLog;
    @observable tipoPreenchido;

    @observable filtroSelecionado;
    @observable filtrado;

    @observable dataInicial;
    @observable dataFinal;
    /** Paginação */
    @observable total;
    @observable hasNextPage;

    /** Infinite Scroll */
    @observable hasMore;
    @observable itens;

    @observable loading;
    constructor() {
        this.tiposLog = [{
            Id:"EmailFaturamento",
            DscTipoLog:"Email Faturamento"
        }];
        this.filtrado = true;
        this.filtroSelecionado = [];

        //inicialização de filtros automaticos
        this.filtroSelecionado["dataInicial"] = moment().subtract(24, 'hours').format('YYYY-MM-DDTHH:mm:ssZ');
        this.filtroSelecionado["dataFinal"] = moment().format('YYYY-MM-DDTHH:mm:ssZ');
        this.filtroSelecionado["tipoLog"]= 'EmailFaturamento';

        this.dataInicial = moment().subtract(24, 'hours');
        this.dataFinal = moment();

        this.tipoPreenchido = {
            value:"EmailFaturamento",
            label:"Email Faturamento"
        };
        

        this.itens = [];
        this.LogEmailLista = [];
        this.loading = false;
        this.filtrosObrigatorios = [];

        /** Paginação */
        this.total = null;
        this.hasNextPage = null;
        this.hasMore = false;
        this.toShow = 20;
        this.turn = 0;


        /** Colunas da Tabela */
        this.todasColunas = [{
            dataField: 'Usuario',
            text: 'Usuario',
            align: "center",
            headerStyle: () => {
                return { width: "200px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'DtAlter',
            text: 'Data de alteração',
            align: "center",
            sort: true,
            formatter: formatarDataCustomHTML,
            sortCaret: sortCaret,
        }, {
            dataField: 'Campo',
            text: 'Campo',
            align: "center",
            align: "center",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Cnpj',
            text: 'Cnpj',
            align: "center",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'ValorAnterior',
            text: 'Valor Anterior',
            align: "center",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'ValorAtual',
            text: 'Valor Atual',
            align: "center",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Operacao',
            text: 'Operação Realizada',
            align: "center",
            sort: true,
            sortCaret: sortCaret,
        }];
        this.colunas = this.todasColunas;

        this.service = new AtualizacaoCadastralService();
    }
    setTipo = (valor) => {
        this.tipoPreenchido = valor;
        this.filtroSelecionado["tipoLog"] = this.tipoPreenchido.value;
    };
    onChangeDataInicio = (data) => {
        if (data === null) {
            this.dataInicial = null;
        } else {
            this.dataInicial = moment(data);
        }
        this.dataInicialPesquisa = data;
        this.filtroSelecionado["dataInicial"] = data;
    };
    onChangeDataFim = (data) => {
        if (data === null) {
            this.dataFinal = null;
        } else {
            this.dataFinal = moment(data);
        }
        this.dataFinalPesquisa = data;
        this.filtroSelecionado["dataFinal"] = data;
    };

    loadFirstTurn = () => {
        this.itens = this.LogEmailLista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.itens.length < this.LogEmailLista.length;
    };

    loadNextTurn = () => {
        this.itens = [];
        this.itens = this.LogEmailLista.slice(0, (this.turn + 1) * this.toShow);
        this.turn = this.turn + 1;

        this.hasMore = this.itens.length < this.LogEmailLista.length;
    };

    validacaoFiltros(){
        return this.filtrosObrigatorios.map(val => !!this.filtroSelecionado[val]).indexOf(false) === -1;
    }

    carregarLista() {
        this.loading = true;
        this.LogEmailLista = [];
        this.itens = [];
        this.total = null;
        this.hasNextPage = null;
        this.hasMore = false;
        this.toShow = 20;
        this.turn = 0;
        

        this.service.BuscarLogEmailFaturamento(this.filtroSelecionado).then(response => {
            if (response) {
                if (response.data) {
                    this.LogEmailLista = response.data;
                    //this.total = response.data.Total;
                    this.total = this.LogEmailLista.length;
                    this.loadFirstTurn()
                    //this.hasNextPage = response.data.HasNextPage;
                    if (this.LogEmailLista.length === 0) {
                        // this.tableMessage = buscaSemResultado
                        toast.info("Sem resultados.");
                    }
                } else {
                    // this.msgFiltro = response.data.Mensagem;
                    alert(response.data.Mensagem);
                }
            } else {
                this.total = 0;
                //this.tableMessage = buscaSemResultado
                this.hasNextPage = false;
            }
        }).catch(error => {
            console.log(error);
        }).finally(() => { this.loading = false;});
        // }  this.atualiza = true; this.carregandoLista = false
        // else{
        //     this.atualiza = true;
        //     this.carregandoLista = false;
        //     {/** TODO: melhorar validação dos campos obrigatórios */}
        //     // this.modalCancelar = true;
        //     // this.responseAcao = "Preencha todos os filtros obrigatórios"
        // }

    }
}


// WEBPACK FOOTER //
// ./src/modules/atualizacaocadastral/stores/LogsStore.js